module.exports = __webpack_public_path__ + "static/media/cp.642e4ea1.png";